// extracted by mini-css-extract-plugin
export default {"imageContainer":"T1-z","summaryPar":"U1-z","ratingCategories":"V1-z","reviewerInfo":"W1-z","reviewTypes":"X1-z","expanded":"Y1-z"};